<ion-content>
  <ion-row class="heading_row">
    <ion-col class="Headingion_col">
      <div>
        <ion-label class="observation_lebel_css">{{'SHIELD_OBSERVATION_LIST.VIEW_OBSERVATIONS'|translate}} ({{obs_length}})</ion-label>
      </div>
      <ion-icon (click)="closeModal()" name="close-outline" class="close_icon"></ion-icon>
    </ion-col>
  </ion-row>
  <div class="heading_row">
    <div class="noDataFound" *ngIf="obs_length == 0">
       {{'SHIELD_OBSERVATION_LIST.NO_DATA_FOUND'|translate}}
    </div>
    <div *ngIf="fromPage !='add-findings'">
      <ion-list style="background: none !important;" *ngIf="!isdataLoaded">
        <div class="skeleton_main_div">
          <ion-card class="skeleton_card" *ngFor="let test of [1,2,3,4,5,6]">
            <ion-label>
              <ion-row>
                <ion-col>
                  <ion-skeleton-text [animated]="true" class="first_row_1col"></ion-skeleton-text>
                  <ion-skeleton-text [animated]="true" class="first_row_2col"></ion-skeleton-text>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-skeleton-text [animated]="true" class="second_row_1col"></ion-skeleton-text>
                  <ion-skeleton-text [animated]="true" class="second_row_2col"></ion-skeleton-text>
                </ion-col>
              </ion-row>
            </ion-label>
          </ion-card>
        </div>
      </ion-list>
      <div *ngIf="isdataLoaded">
        <ion-card class="list_card" *ngFor="let obs of observation_list" >
          <ion-row>
            <ion-col class="id_col" (click)="editObservation(obs,'rapid-findings-list')">
              <ion-label class="observation_id_css">{{obs.type}}</ion-label> 
              <!-- <span class="obsType" >{{obs.type}}</span> -->
              <ion-icon *ngIf="edit_flag" class="arrow_icon" name="chevron-forward-outline"></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="desc_col">
              <ion-label *ngIf="obs.type !='HAZ' && obs.description" class="observation_desc_css"> {{(obs.readMore) ? obs.description : obs.description| slice:0:50}} 
                <!-- <span class="more_link more_css" *ngIf="!obs.readMore && (obs.description).length > 50">...</span> -->
                <u  class="more_css" *ngIf="!obs.readMore && (obs.description).length > 50" (click)="obs.readMore=true">...{{'SHIELD_DETAILS_VIEW_PAGE.MORE_TEXT'|translate}}</u>
                <u  class="more_css" *ngIf="obs.readMore && (obs.description).length > 50" (click)="obs.readMore=false">{{'SHIELD_DETAILS_VIEW_PAGE.LESS_TEXT'|translate}}</u>
              </ion-label>
              <ion-label *ngIf="obs.type =='HAZ' && obs.detailed_description" class="observation_desc_css">{{(obs.readMore) ? obs.detailed_description : obs.detailed_description| slice:0:50}}
                <!-- <span class="more_link more_css" *ngIf="!obs.readMore && (obs.detailed_description).length > 50">...</span> -->
                <u class="more_css" *ngIf="!obs.readMore && (obs.detailed_description).length > 50" (click)="obs.readMore=true">... {{'SHIELD_DETAILS_VIEW_PAGE.MORE_TEXT'|translate}}</u>
                <u class="more_css" *ngIf="obs.readMore && (obs.detailed_description).length > 50" (click)="obs.readMore=false">{{'SHIELD_DETAILS_VIEW_PAGE.LESS_TEXT'|translate}}</u>
              </ion-label>
            </ion-col>
          </ion-row>
        </ion-card>
      </div>
    </div>
    <!-- <div *ngIf="fromPage =='add-findings'">
      <ion-list lines="none">
        <cdk-virtual-scroll-viewport [itemSize]="observation_list?.length" minBufferPx="900" maxBufferPx="1350">
          <ion-card class="list_card" *cdkVirtualFor="let item of observation_list" (click)="addSelectedObs(item)">
            <ion-row>
              <ion-col class="id_col">
                <ion-label class="obs_id" (click)="editObservation(item,'add-findings')">{{item.id}}</ion-label>  <span class="obsType" >{{item.type}}</span>
                <ion-checkbox slot="" class="ion_check_box" [(ngModel)]="item.isChecked">
                </ion-checkbox>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="desc_col">
                <ion-label *ngIf="item.type !='HAZ'" class="observation_desc_css">{{item.description}}</ion-label>
                <ion-label *ngIf="item.type =='HAZ'" class="observation_desc_css">{{item.detailed_description}}</ion-label>
              </ion-col>
            </ion-row>
          </ion-card>
         </cdk-virtual-scroll-viewport>
     </ion-list>
    </div> -->
  </div>
</ion-content>
<ion-footer *ngIf="fromPage =='add-findings'">
  <ion-row class="footer_row">
    <ion-col (click)="refreshList()">
        <ion-label>{{'SHIELD_OBSERVATION_LIST.REFRESH'|translate}}</ion-label>
    </ion-col>
    <ion-col  (click)="addObsList()">
        <ion-label >{{'SHIELD_OBSERVATION_LIST.ADD'|translate}}
        </ion-label>
    </ion-col>
  </ion-row>
</ion-footer>